import Vue from 'vue'
import Router from 'vue-router'
import {Dashboard, Login, NotFound, ShopifyFinalize, SyncNewPage, SyncEditPage, LogsPage} from '../components/'
import {Auth} from '../helpers/'

Vue.use(Router)

const router = new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            name: 'dashboard',
            component: Dashboard,
            meta: {
                authRequired: true,
                showPremiumBanner: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/shopify/finalize',
            name: 'shopify-finalize',
            component: ShopifyFinalize,
        },
        {
            path: '/logs',
            name: 'logs',
            component: LogsPage,
            meta: {
                authRequired: true,
                breadcrumb: {
                    path: "/",
                    from: "Dashboard",
                    to: "Logs"
                },
            }
        },
        {
            path: '/syncs/new',
            name: 'new-sync-list',
            component: SyncNewPage,
            meta: {
                authRequired: true,
                breadcrumb: {
                    path: "/",
                    from: "Dashboard",
                    to: "Select Sync Type"
                },
            }
        },
        {
            path: '/syncs/new/:selectedCase',
            props: true,
            name: 'new-sync',
            component: SyncNewPage,
            meta: {
                breadcrumb: {
                    path: "/",
                    from: "Dashboard",
                    to: "New Sync"
                },
                authRequired: true
            }
        },
        {
            path: '/syncs/:syncId',
            props: true,
            name: 'edit-sync',
            component: SyncEditPage,
            meta: {
                authRequired: true,
                breadcrumb: {
                    path: "/",
                    from: "Dashboard",
                    to: "Edit Sync"
                },
            }
        },
        {
            path: '*',
            name: 'notFound',
            component: NotFound
        },
    ]
})

router.beforeEach((to, from, next) => {
    if (to.meta.authRequired && !Auth.user) next({ name: 'login' })
    else next()
})

export default router